export const intlTelInputErrorIndex = {
  invalidFormat: 0,
  invalidCountryCode: 1,
  numberTooShort: 2,
  numberTooLong: 3,
  inputEmpty: 4,
  inputNull: -99,
};
